/** E-Mail-Validierung/-Normalisierung (pragmatisch, kein React). */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Trimmt und setzt den Domain-Teil auf Kleinbuchstaben (Local-Part bleibt). */
export function normalizeEmail(input: string): string {
  const trimmed = String(input ?? "").trim();
  if (!trimmed) return "";
  const at = trimmed.lastIndexOf("@");
  if (at < 0) return trimmed;
  return trimmed.slice(0, at) + "@" + trimmed.slice(at + 1).toLowerCase();
}

/** Leere Eingabe = gültig (optionales Feld). */
export function validateEmail(input: string): { valid: boolean; error?: string } {
  const trimmed = String(input ?? "").trim();
  if (!trimmed) return { valid: true };
  return EMAIL_RE.test(trimmed)
    ? { valid: true }
    : { valid: false, error: "Bitte eine gültige E-Mail-Adresse eingeben" };
}
